export const PASSWORD_REGEX = /(?=.*[a-z])(?=.*\d)(?=.*[_\-.`=+?,<>;:'"}{\]~!@#$%^&*()|/\\])^[a-zA-Z\d_\-.`=+?,<>;:'"}{\]~!@#$%^&*()|/\\]+$/i
export const NAME_REGEX = /^[а-яa-z-]{1,32}$/i